export type VerificationResult = "valid" | "invalid" | "blacklisted" | "error";

export interface VerificationResponse {
    result: VerificationResult;
}

export interface TokenVerification extends VerificationResponse {
    token: string;
}

export interface JwtToken {
    exp: number;
    iat: number;
    persist: boolean;
}

export interface FormResponseToken {
    do: "setToken";
    arg: string;
}

export interface FormResponseAction {
    do: "showSlot";
    arg: "thanks" | "blocked" | "error";
}

export interface FormResponseValidationError {
    do: "showMarkup";
    arg: string; // HTML markup
}

export interface FormResponseError {
    error: string;
}

export type FormResponse =
    | FormResponseToken
    | FormResponseAction
    | FormResponseValidationError
    | FormResponseError;
